import { Inline, Tag } from '@superdispatch/ui';
import { AccountOffIcon } from 'shared/icons';
import { LoadDTO } from '../data/LoadDTO';

interface DriverDisconnectedTagProps {
  driver: LoadDTO['driver'];
}

export function DriverDisconnectedTag({ driver }: DriverDisconnectedTagProps) {
  const isDisconnected = driver?.connection_status === 'deactivated';
  const isSuspended = driver?.is_role_active === false;

  if (isDisconnected) {
    return (
      <Tag variant="subtle" color="red">
        <Inline space="xxsmall" verticalAlign="center">
          <AccountOffIcon fontSize="small" />
          Deactivated
        </Inline>
      </Tag>
    );
  }

  if (isSuspended) {
    return (
      <Tag variant="subtle" color="red">
        <Inline space="xxsmall" verticalAlign="center">
          <AccountOffIcon fontSize="small" />
          Inactive as Driver
        </Inline>
      </Tag>
    );
  }

  return null;
}
